import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./Home";
import Layout from './Layout';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth, { RequireAdmin, RequireCvOwner } from './auth/RequireAuth';
import Hosting from './Pages/Hosting';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Checkout from './Pages/Checkout';
import OrderPage from './Pages/OrderPage';
import Account from './Pages/Account';
import ControlPanel from './Pages/panel/ControlPanel';
import NotFound from './Pages/NotFound';
import AdminCustomers from './Pages/admin/AdminCustomers';
import AdminCustomer from './Pages/admin/AdminCustomer';
import CvGenerator from './Pages/CvGenerator';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true,     // Whether animation should happen only once
      offset: 100,    // Offset (in px) from the original trigger point
    });
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="hosting" element={<Hosting />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="checkout/order/:orderId" element={<RequireAuth to="/login"><OrderPage /></RequireAuth>} />
            <Route path="checkout/:slug" element={<RequireAuth><Checkout /></RequireAuth>} />
            <Route path="account" element={<RequireAuth to="/login"><Account /></RequireAuth>} />
            <Route path="panel/:serviceId" element={<RequireAuth to="/login"><ControlPanel /></RequireAuth>} />
            <Route path="admin" element={<RequireAdmin><AdminCustomers /></RequireAdmin>} />
            <Route path="admin/customers/:customerId" element={<RequireAdmin><AdminCustomer /></RequireAdmin>} />
            <Route path="cv" element={<RequireCvOwner><CvGenerator /></RequireCvOwner>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
